import { backendURL } from "../utils/constants/constants";

export async function postInfluencer({ body }) {

    try {
        const response = await fetch(`${backendURL}/influencer/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function postCompany({ body }) {

    try {
        const response = await fetch(`${backendURL}/company/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function postEmailToObtainVerificationCode({ email }) {

    try {
        const response = await fetch(`${backendURL}/mail/enviarMail?mail=${email}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getStatusVerificationCode({ code, email }) {

    try {
        const response = await fetch(`${backendURL}/mail/verificarCodigo?code=${code}&mail=${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}